/**
 * El hilo que se está mirando se pide solo.  (033 · FR-006)
 *
 * No es el intervalo de la cabecera (054) ni `refetchInterval`
 * (001 · FR-012): el efecto vive en el componente, así que
 * cerrar la conversación lo para. La pestaña oculta también.
 */

export const REFRESCO_HILO_ABIERTO_MS = 1_000

export function tocaRefrescarHilo(abierto: boolean, pestañaOculta: boolean): boolean {
    return abierto && !pestañaOculta
}
